import React from 'react';
import { Switch, Route } from 'react-router-dom';

// pages
import List from './List';
import Item from './Item';

class UserPages extends React.PureComponent {
    render() {
        const { url } = this.props.match;
        return (
            <Switch>
                <Route exact path={`${url}/list`} component={List} />
                <Route exact path={`${url}/item`} component={Item} />
            </Switch>
        );
    }
}
export default UserPages;
